import { fg } from '@atlaskit/platform-feature-flags';
import { mdPlusSuggestionGenerator } from './md-plus-suggestion-generator';
import { suggestionGenerator } from './suggestion-generator';

// NOTE: It's important that we maintain a consistent API regardless of which endpoint we hit.
// This is a generic interface we should be able to use for any version of the provider.

/**
 * This will filter out chunks from being streamed to the service which are not valid.
 */
export var isChunkExcluded = function isChunkExcluded(chunk) {
  return chunk.from === chunk.to || !chunk.text || !chunk.text.trim().length;
};

/* istanbul ignore next */
// This V1 endpoint is the final endpoint we're targetting for hello release.
export var fetchAIParagraphs = function fetchAIParagraphs(view, proactiveAIApiUrl, locale) {
  return function (paragraphs) {
    if (fg('platform_editor_ai_proactive_ai_md_plus')) {
      return mdPlusSuggestionGenerator({
        endpoint: proactiveAIApiUrl,
        editorView: view,
        paragraphs: paragraphs
      });
    }
    var included = paragraphs.filter(function (chunk) {
      return !isChunkExcluded(chunk);
    });
    if (!!included.length) {
      return suggestionGenerator({
        endpoint: proactiveAIApiUrl,
        paragraphs: included,
        abortController: new AbortController()
      });
    }
    return;
  };
};